const ErrorMessage = ({error}: any) => {
  if (error) {
    return (
      <>
        <div className='fv-plugins-message-container invalid-feedback'>
          <i className='bi bi-exclamation-circle-fill text-danger me-2'></i>
          <span role='alert'>{error}</span>
        </div>
      </>
    )
  }
  return null
}

export default ErrorMessage
